import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import imgAdults from "../../../../assets/images/adults.png";
import imgChildren from "../../../../assets/images/children.png";

import imgTachNeedle from "../../../../assets/images/tachometer/TachNeedle.png";
import imgTach1 from "../../../../assets/images/tachometer/T1.png";
import imgTach2 from "../../../../assets/images/tachometer/T2.png";
import imgTach3 from "../../../../assets/images/tachometer/T3.png";
import imgTach4 from "../../../../assets/images/tachometer/T4.png";
import imgTach5 from "../../../../assets/images/tachometer/T5.png";
import imgTachNA from "../../../../assets/images/tachometer/na.png";

function TransplantSummary(props) {

    const [transplantType, setTransplantType] = useState("Adult");

    let imgIcon = transplantType === "Adult" ? imgAdults : imgChildren;
    let organName = "";
    let showLiving = false;

    if (props.organ === "ki") {
        organName = "Kidney";
        showLiving = true;
    }
    if (props.organ === "kp") {
        organName = "Kidney-Pancreas";
    }
    if (props.organ === "hr") {
        organName = "Heart";
    }
    if (props.organ === "hl") {
        organName = "Heart-Lung";
    }
    if (props.organ === "li") {
        organName = "Liver";
        showLiving = true;
    }
    if (props.organ === "lu") {
        organName = "Lung";
    }
    if (props.organ === "in") {
        organName = "Intestine";
    }
    if (props.organ === "pa") {
        organName = "Pancreas";
    }
    if (props.organ === "hk") {
        organName = "Heart-Kidney";
    }
    if (props.organ === "lk") {
        organName = "Liver-Kidney";
    }

    let deceasedDonorsInYear = transplantType.toLowerCase() === "adult" ? props.data.cadtx_adn_c : props.data.cadtx_p0n_c;
    let livingDonorsInYear = transplantType.toLowerCase() === "adult" ? props.data.litx_adn_c : props.data.litx_p0n_c;
    let survivalOnWaitlist = transplantType.toLowerCase() === "adult" ? GetTach(props.data.tmr_ad_dthrscore_c) : GetTach(props.data.tmr_p0_dthrscore_c);
    let getttingDeceasedDonorTransplant = transplantType.toLowerCase() === "adult" ? GetTach(props.data.tmr_ad_cadtxrscore_c) : GetTach(props.data.tmr_p0_cadtxrscore_c);
    let survivalFollowingTransplant = transplantType.toLowerCase() === "adult" ? GetTach(props.data.gsr_ad_score_c1y) : GetTach(props.data.gsr_p0_score_c1y);

    let topRow = (
        <div className="top-row">
            <div className="title-wrapper">
                <img src={imgIcon} alt={`${transplantType} ${organName} Transplants`} />
                <div className="title">
                    {`${transplantType} ${organName} Transplant Summary`}
                </div>
            </div>
            <div className="button">
                <Button
                    onClick={() => setTransplantType(transplantType === "Adult" ? "Pediatric" : "Adult")}
                    className="btn-dark-blue min-98"
                >
                    {transplantType === "Adult" && "Show Pediatric"}
                    {transplantType !== "Adult" && "Show Adult"}
                </Button>
            </div>
        </div>
    );

    if (!deceasedDonorsInYear && !livingDonorsInYear) {
        let noDataMessage = ["hk", "lk"].includes(props.organ)
            ? `Not Calculated for ${organName} Programs`
            : `No ${transplantType} ${organName} Transplants Performed`;

        return (
            <Row>
                <Col>
                    <div className="organ-summary">
                        {topRow}
                        <div className="tier-wrapper no-results">
                            {noDataMessage}  
                        </div>
                    </div>
                </Col>
            </Row>
        )
    }

    return (
        <Row>
            <Col>
                <div className="organ-summary">
                    {topRow}
                    <div className={!showLiving ? "tier-wrapper four" : "tier-wrapper"}>
                        <div className="item">
                            <div className="text">
                                Transplants from Deceased Donors in a year
                         </div>
                            <div className="stat">
                                {deceasedDonorsInYear}
                            </div>
                        </div>
                        {showLiving &&
                            <div className="item">
                                <div className="text">
                                    Transplants from Living Donors in a year
                        </div>

                                <div className="stat">
                                    <div>{livingDonorsInYear}</div>
                                </div>
                            </div>
                        }
                        <div className="item">
                            <div className="text">
                                Survival on the waitlist
                        </div>
                            <div className="stat">
                                {survivalOnWaitlist}
                            </div>
                        </div>
                        <div className="item">
                            <div className="text">
                                Getting a Deceased Donor Transplant Faster
                        </div>
                            <div className="stat">
                                {getttingDeceasedDonorTransplant}
                            </div>
                        </div>
                        <div className="item">
                            <div className="text">
                                1-Year {organName} Survival
                            </div>
                            <div className="stat">
                                {survivalFollowingTransplant}
                            </div>
                        </div>
                    </div>

                </div>
            </Col>
        </Row>
    );
}

function GetTach(score) {
    if (!score) return <div><img src={imgTachNA} alt="Not Assessed" /></div>;

    var angle = -90 + (score * 180);
    var tachsrc = score < 0.125 ? imgTach1 : 
                    score < 0.375 ? imgTach2 :
                    score < 0.625 ? imgTach3 :
                    score < 0.875 ? imgTach4 :
                    imgTach5;
                   
    var tachimg = <img id="tachFace" className="tach-face" src={tachsrc} alt="Tachometer" />
    
    return (
        <div class="d-flex flex-column align-items-center">
            <div className="tach-wrap">
                {tachimg}
                <img id="tachNeedle" 
                    className="tach-needle"
                    style={{
                        transform: `translateX(-50%) rotate(${angle}deg)`
                        }}
                    src={imgTachNeedle} 
                    alt="Tach needle" />
            </div>
        </div>
    )
}

export default TransplantSummary;